module.exports = __webpack_public_path__ + "static/img/vip_privilege3.42965dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vip/vip_privilege3.png
// module id = 17io
// module chunks = 0